/* WI email capture — right-side slide-out drawer (2026-08-24).
 * Ported from the Paragraph US desktop email-capture build.
 *
 * Gates (in order): config present + enabled + listId set; desktop
 * viewport, or mobile switched on in theme settings; not the theme
 * editor; not already signed up (wi_ec_done); not inside the dismiss
 * cooldown.
 * Triggers, desktop (990px and up): scroll start (+ short dwell) OR
 * delay timer OR exit intent — first wins.
 * Triggers, below 990px (2026-10-12): the surface is a bottom sheet and
 * it never opens on the first scroll. It opens once the shopper has
 * scrolled past the main Add to Cart button and then stopped for
 * scrollDelayMs; on a page with no Add to Cart button, once they are
 * 60% of the way down and have stopped. The mobile delay timer still
 * opens it too, but waits while a drawer is open or the Add to Cart
 * button is on screen.
 *
 * Subscribe posts to Klaviyo's Client API (/client/subscriptions),
 * the same call the footer strip makes. It moved off the legacy
 * kmail-lists AJAX endpoint on 2026-09-06 after Klaviyo's bot
 * protection suppressed real drawer sign-ups. Success/dismiss recorded
 * in localStorage. Every analytics event carries a client event_id
 * so downstream (GA4 -> Meta CAPI Lead) can dedup — a gap found in
 * the Paragraph build's tracking audit.
 */
(function () {
  var cfgEl = document.getElementById('wi-ec-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.enabled || !cfg.listId) return;

  var isDesktop = window.matchMedia('(min-width: 990px)').matches;
  if (!isDesktop && !cfg.mobile) return;
  if (window.Shopify && window.Shopify.designMode) return;

  /* Client preview: ?signup=preview opens the drawer immediately,
     bypassing the dismissed/done gates. */
  var FORCE = /[?&]signup=preview/.test(location.search);

  var LS_DONE = 'wi_ec_done';
  var LS_DISMISSED = 'wi_ec_dismissed_at';
  if (!FORCE) {
    try {
      if (localStorage.getItem(LS_DONE) === '1') return;
      var dismissedAt = parseInt(localStorage.getItem(LS_DISMISSED) || '0', 10);
      if (dismissedAt && (Date.now() - dismissedAt) < cfg.cooldownDays * 864e5) return;
    } catch (e) { /* storage blocked: still show, just no persistence */ }
  }

  var el = document.querySelector('.wi-ec');
  var scrim = document.querySelector('.wi-ec__scrim');
  if (!el) return;

  function eventId() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'wiec-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
  }
  function track(event, extra) {
    var payload = { event: event, ec_surface: 'theme_drawer', event_id: eventId() };
    if (extra) for (var k in extra) payload[k] = extra[k];
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  }

  var opened = false;
  var delayTimer = null;
  var suppressed = false;

  /* Never interrupt a shopper who is buying. A timer armed while the cart was
     empty would otherwise fire over the cart drawer or the checkout click —
     on mobile the sheet and its scrim cover the screen at z-index 10050, so
     they swallow the tap and leave them on the product page with the item
     still in the cart.
     Liquid's cart.item_count is render-time only and goes stale the moment
     ajax-cart adds a line, so read the live count the theme keeps in the
     header instead, and treat any checkout intent as permanent suppression. */
  function count(node) {
    if (!node) return 0;
    return parseInt((node.textContent || '').replace(/\D/g, ''), 10) || 0;
  }
  function hasCart() {
    /* Header badge renders on every page and ajax-cart keeps it current;
       the drawer heading pill only exists once the drawer has been built. */
    return count(document.querySelector('.js-wi-cart-badge')) > 0 ||
           count(document.querySelector('[data-wi-cart-count]')) > 0;
  }

  function suppress() {
    suppressed = true;
    cleanupTriggers();
  }

  /* Capture phase: fire before the cart form's own submit handler, so the
     drawer is disarmed even if navigation starts in the same tick. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('a[href*="/checkout"], button[name="checkout"], [data-wi-checkout]')) suppress();
  }, true);
  document.addEventListener('submit', function (e) {
    if (e.target.matches('form[action*="/cart"]')) suppress();
  }, true);

  /* Below 990px the surface is a bottom sheet over a dimmed page, and the
     page must not scroll underneath it. The lock is a class on <html>
     (overflow: hidden, in wi-email-capture.css). It leaves the scroll
     position untouched, so closing puts the shopper back exactly where
     they were with no scroll restore, and the sticky header and buy bar
     behind the sheet do not change state. Desktop keeps scrolling behind
     its side drawer, as before. */
  var locked = false;
  function lockScroll() {
    if (isDesktop || locked) return;
    locked = true;
    document.documentElement.classList.add('wi-ec-lock');
  }
  function unlockScroll() {
    if (!locked) return;
    locked = false;
    document.documentElement.classList.remove('wi-ec-lock');
  }
  /* A drag that starts on the dimmed area must not move the page either.
     The scrim has touch-action: none; this covers browsers that ignore it. */
  if (scrim) {
    scrim.addEventListener('touchmove', function (e) {
      if (locked && e.cancelable) e.preventDefault();
    }, { passive: false });
  }

  function open(trigger) {
    /* Re-check at fire time, not just at arm time: the cart can fill in the
       seconds between. FORCE keeps the client preview working with a cart. */
    if (opened || suppressed) return;
    if (!FORCE && hasCart()) return;
    opened = true;
    cleanupTriggers();
    el.hidden = false;
    if (scrim) scrim.hidden = false;
    lockScroll();
    /* Double rAF so the browser paints the off-screen position first and
       the transform transition actually animates. rAF is paused entirely
       in a hidden tab, which would leave the drawer un-hidden but parked
       off-canvas, so a timeout backstops it. */
    var slid = false;
    function slideIn() {
      if (slid) return;
      slid = true;
      el.classList.add('is-open');
      if (scrim) scrim.classList.add('is-open');
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(slideIn);
    });
    setTimeout(slideIn, 120);
    if (isDesktop) {
      setTimeout(function () {
        var input = el.querySelector('.wi-ec__input');
        if (input) input.focus({ preventScroll: true });
      }, 450);
    }
    track('wi_email_capture_view', { ec_trigger: trigger });
  }

  function close(reason, persist) {
    unlockScroll();
    el.classList.remove('is-open');
    if (scrim) scrim.classList.remove('is-open');
    setTimeout(function () {
      el.hidden = true;
      if (scrim) scrim.hidden = true;
    }, 450);
    if (persist) {
      try { localStorage.setItem(LS_DISMISSED, String(Date.now())); } catch (e) {}
      track('wi_email_capture_dismiss', { ec_reason: reason });
    }
  }

  /* Triggers */
  /* Scroll opens the drawer shortly after the reader starts moving, rather
     than at a depth threshold: on a short page the old percentage gate could
     never be reached. A small pixel floor keeps a stray wheel nudge or an
     anchor jump from counting, and the dwell lets them read a little first. */
  var scrollTimer = null;
  function onScroll() {
    if (scrollTimer || window.scrollY < cfg.scrollMinPx) return;
    scrollTimer = setTimeout(function () { open('scroll'); }, cfg.scrollDelayMs);
  }
  function onExit(e) {
    if (e.clientY <= 0) open('exit_intent');
  }

  /* ---- Below 990px: wait for the buy point, then for a pause ----
     The old rule (120px of scroll, then 1.5s) opened a full-screen panel
     before a phone shopper could reach Add to Cart, which sits about 1.7
     screens down the product page. */

  /* The Add to Cart button the shopper has to get past. On a product page
     that is the product form's own button. On a page with several (the
     homepage has one per bottle) it is the lowest one, so the sheet waits
     until they are past all of them. The sticky buy bar and the drawers
     are fixed to the screen and can never be "passed", so they are left
     out. */
  function mainAtc() {
    var main = document.getElementById('AddToCart');
    if (main && main.getClientRects().length) return main;
    var nodes = document.querySelectorAll('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] [name="add"]');
    var lowest = null;
    var lowestBottom = -Infinity;
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].closest('#StickyAtcBar, .drawer')) continue;
      if (!nodes[i].getClientRects().length) continue;
      var b = nodes[i].getBoundingClientRect().bottom;
      if (b > lowestBottom) { lowestBottom = b; lowest = nodes[i]; }
    }
    return lowest;
  }
  /*  1: the shopper has scrolled past the buy point.
      0: not yet.
     -1: scrolling can never get there on this page (it is too short), so
         the delay timer decides instead. */
  function buyPointState() {
    var doc = document.documentElement;
    var y = window.pageYOffset || doc.scrollTop || 0;
    var max = Math.max(0, doc.scrollHeight - window.innerHeight);
    var atc = mainAtc();
    if (atc) {
      /* Past = the whole button has left the top of the screen. */
      var bottom = atc.getBoundingClientRect().bottom;
      if (bottom + y >= max) return -1;
      return bottom < 0 ? 1 : 0;
    }
    /* No Add to Cart on the page: 60% of the way down. scrollMinPx is the
       floor below which a page does not count as scrollable. */
    if (max < cfg.scrollMinPx) return -1;
    return y / max >= 0.6 ? 1 : 0;
  }
  /* The theme locks the page by fixing <body> while its menu or cart
     drawer is open, which fires a scroll event and zeroes scrollY. Never
     read the scroll position, or open the sheet, on top of a drawer. */
  function drawerOpen() {
    return /(^|\s)js-drawer-open(\s|$)/.test(document.documentElement.className + ' ' + document.body.className);
  }
  /* Every scroll event restarts the wait, so the sheet can only open after
     the shopper has stopped moving for scrollDelayMs. */
  function onScrollMobile() {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      scrollTimer = null;
      if (drawerOpen() || buyPointState() !== 1) return;
      open('scroll');
    }, cfg.scrollDelayMs);
  }
  function atcOnScreen() {
    var atc = mainAtc();
    if (!atc) return false;
    var r = atc.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }
  /* The mobile timer is a second way in (operator ruling 09-01, 30s), so a
     shopper who stays on the page without scrolling past Add to Cart still
     gets the offer. It holds off, checking again every 5s, while a drawer
     is open or the Add to Cart button is on screen, so the sheet never
     covers the button they are about to press. A page too short to scroll
     past the button would hold forever, so there the timer opens at once. */
  function onDelayMobile() {
    delayTimer = null;
    if (drawerOpen() || (buyPointState() !== -1 && atcOnScreen())) {
      delayTimer = setTimeout(onDelayMobile, 5000);
      return;
    }
    open('delay');
  }

  function cleanupTriggers() {
    if (delayTimer) clearTimeout(delayTimer);
    if (scrollTimer) clearTimeout(scrollTimer);
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('scroll', onScrollMobile);
    document.documentElement.removeEventListener('mouseleave', onExit);
  }
  /* Don't arm anything for a shopper who already has a cart — they are in
     the funnel, and the sign-up is not worth the interruption. Preview still
     bypasses this so the client can review the drawer with a stocked cart. */
  if (!FORCE && hasCart()) return;

  /* Trigger mode from theme settings: 'delay' (after N seconds on
     landing), 'scroll' (after scroll depth), 'exit' (exit intent,
     desktop only), or 'any' — first of the three to fire. */
  var mode = cfg.trigger || 'any';
  var scrollArmed = (mode === 'any' || mode === 'scroll');
  if (mode === 'any' || mode === 'delay') {
    if (FORCE) { setTimeout(function () { open('preview'); }, 400); }
  /* Mobile waits longer than desktop (operator ruling 09-01, 30s), and
     since 2026-10-12 its timer holds while Add to Cart is on screen (see
     onDelayMobile). Desktop keeps its own delay. */
  var delaySec = isDesktop ? cfg.delaySeconds : (cfg.delaySecondsMobile || 30);
  delayTimer = setTimeout(isDesktop ? function () { open('delay'); } : onDelayMobile, delaySec * 1000);
  }
  if (scrollArmed) {
    window.addEventListener('scroll', isDesktop ? onScroll : onScrollMobile, { passive: true });
  }
  if (isDesktop && (mode === 'any' || mode === 'exit')) {
    document.documentElement.addEventListener('mouseleave', onExit);
  }

  /* Dismissal */
  var closeBtn = el.querySelector('.wi-ec__close');
  if (closeBtn) closeBtn.addEventListener('click', function () { close('close_button', true); });
  if (scrim) scrim.addEventListener('click', function () { close('scrim', true); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !el.hidden) close('escape', true);
  });

  /* Submit */
  var form = el.querySelector('.wi-ec__form-wrap form:not(.wi-ec__form2)');
  var form2 = el.querySelector('.wi-ec__form2');
  var skipBtn = el.querySelector('.wi-ec__skip');
  var errorEl = el.querySelector('.wi-ec__error');
  var successEl = el.querySelector('.wi-ec__success');
  var subscriberEmail = '';

  /* Reveal the success panel and close on a delay so the confirmation is
     read before the drawer slides away. Called from step 2 (submit or
     skip) or directly when the name step is off. */
  /* Auto-apply the welcome discount (2026-10-05). The offer used to arrive
     only by email, so a shopper in the Facebook or Instagram app had to
     leave the app, find the code and come back; Clarity recordings showed
     them doing exactly that, and no abandoned checkout has ever carried a
     code. GET /discount/<code> sets Shopify's discount cookie, so the
     checkout opens with the code already applied. Fire and forget: the
     sign-up is already banked and a failure here must not surface. */
  function applyWelcomeCode() {
    var code = (cfg.autoCode || '').trim();
    if (!code) return;
    try { localStorage.setItem('wi_ec_code', code); } catch (err) {}
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', {
      credentials: 'same-origin'
    }).catch(function () {});
    track('wi_email_capture_code_applied', { ec_code: code });
  }

  function finish(reason) {
    if (form2) form2.hidden = true;
    if (successEl) successEl.hidden = false;
    setTimeout(function () { close(reason, false); }, 3200);
  }

  /* Step 2 posts the name to Klaviyo's client profiles endpoint, which
     accepts the public company id — the same key the onsite snippet uses.
     Failure here is silent: the email is already banked, and a lost first
     name is not worth showing the subscriber an error. */
  function submitName(name) {
    if (!cfg.companyId || !subscriberEmail) return;
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: '2024-10-15'
      },
      body: JSON.stringify({
        data: {
          type: 'profile',
          attributes: { email: subscriberEmail, first_name: name }
        }
      }),
      keepalive: true
    }).catch(function () {});
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = el.querySelector('.wi-ec__input');
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      if (errorEl) errorEl.hidden = false;
      return;
    }
    if (errorEl) errorEl.hidden = true;

    /* Subscribe through Klaviyo's Client API (the same call the footer
       strip makes). The legacy manage.kmail-lists.com AJAX endpoint is
       the surface Klaviyo's bot protection polices: on 4-5 Sep 2026 it
       suppressed 4 of 22 real drawer sign-ups as bots within a minute
       of subscribing. Client API sign-ups carry explicit consent and a
       custom_source, and none from the footer were flagged. Returns
       202 with no body on success.

       Do NOT put a `subscriptions` block inside the profile attributes:
       the Client API rejects it with 400 ("'subscriptions' is not a
       valid field for the resource 'profile'"), the fetch throws, and
       the sign-up is silently lost. Consent is implied by the call
       itself: Klaviyo records email marketing SUBSCRIBED and adds the
       profile to the list. Verified live 2026-09-07. */
    var props = { signup_surface: 'theme_drawer' };
    if (cfg.country) props.signup_country = cfg.country;
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: props
              }
            }
          },
          custom_source: 'Wild Idol US - theme drawer'
        },
        relationships: {
          list: { data: { type: 'list', id: cfg.listId } }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(payload),
      keepalive: true
    }).then(function (r) {
      if (!(r.status === 202 || r.ok)) throw new Error('subscribe_failed');
      return true;
    }).then(function () {
      try { localStorage.setItem(LS_DONE, '1'); } catch (err) {}
      subscriberEmail = email;
      form.hidden = true;
      applyWelcomeCode();
      /* identify() first — it awaits SHA-256, and every event pushed before
         it resolves ships without user_data.em. Then emailSignup, which is
         the event the Meta CAPI Lead regex and the Google Ads signup tag
         actually match — the custom wi_email_capture_submit below is
         analytics-only and invisible to the ad platforms. Nothing navigates
         here, so no POST-holding: just order the pushes, with a 500ms cap
         so tracking can never hang the success UI. */
      var fireSignup = function () {
        if (window.LBMGB && LBMGB.track && typeof LBMGB.track.emailSignup === 'function') {
          try { LBMGB.track.emailSignup({ email: email, source: 'theme_drawer', list: 'newsletter' }); } catch (err) {}
        }
        track('wi_email_capture_submit');
      };
      var signupDone = false;
      var signupOnce = function () { if (!signupDone) { signupDone = true; fireSignup(); } };
      var identified = null;
      if (window.LBMGB && LBMGB.track && typeof LBMGB.track.identify === 'function') {
        try { identified = LBMGB.track.identify({ email: email }); } catch (err) {}
      }
      if (identified && typeof identified.then === 'function') {
        identified.then(signupOnce, signupOnce);
        setTimeout(signupOnce, 500);
      } else {
        signupOnce();
      }
      if (cfg.nameStep && form2) {
        form2.hidden = false;
        var nameInput = form2.querySelector('.wi-ec__input--name');
        if (isDesktop && nameInput) {
          setTimeout(function () { nameInput.focus({ preventScroll: true }); }, 120);
        }
      } else {
        finish('signup_complete');
      }
    }).catch(function () {
      if (errorEl) {
        errorEl.textContent = 'Something went wrong — please try again.';
        errorEl.hidden = false;
      }
    });
  });

  if (form2) {
    form2.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameInput = form2.querySelector('.wi-ec__input--name');
      var name = ((nameInput && nameInput.value) || '').trim();
      if (name) {
        submitName(name);
        track('wi_email_capture_name_submit');
      } else {
        track('wi_email_capture_name_skip', { ec_reason: 'empty' });
      }
      finish('signup_complete');
    });
  }

  if (skipBtn) {
    skipBtn.addEventListener('click', function () {
      track('wi_email_capture_name_skip', { ec_reason: 'skip_button' });
      finish('signup_complete');
    });
  }
})();
